// extracted by mini-css-extract-plugin
export default {"iframeContainer":"XlNToE"};